import { authApi } from './authApi';

export const createFolder = async (payload: any) => {
  return await authApi.post('contracts/folder/', payload);
};

export const editFolder = async (payload: any) => {
  return await authApi.patch(`contracts/folder/${payload?.id}/`, payload?.body);
};

export const bulkDeleteFolders = async (payload: { folder_ids: string[] }) => {
  return await authApi.post('contracts/folder/bulk-delete/', payload);
};

export const moveToFolders = async (
  folderId: string,
  payload: { contract_ids: string[] }
) => {
  return await authApi.post(
    `contracts/folder/${folderId}/move-contracts/`,
    payload
  );
};

export const removeContractsFromFolder = async (payload: {
  contract_ids: string[];
}) => {
  return await authApi.post(`contracts/folder/remove-contracts/`, payload);
};

export const fetchFoldersTree = async (search?: string): Promise<any> => {
  const q = search?.trim()
    ? `?search=${encodeURIComponent(search.trim())}`
    : '';
  return await authApi.get(`contracts/folder/tree/${q}`);
};
